import { render } from "./ks-short-biography-text.vue?vue&type=template&id=5e1f92e8"
import script from "./ks-short-biography-text.vue?vue&type=script&lang=js"
export * from "./ks-short-biography-text.vue?vue&type=script&lang=js"

import "./ks-short-biography-text.vue?vue&type=style&index=0&id=5e1f92e8&lang=css"
script.render = render

export default script